// ftaPaletteConfig.ts — Shared colour map and palette item list for FTA editor
import { FTANodeType } from '../../types/fta.types';

export type ColorSet = { fill: string; stroke: string };

export const TYPE_COLORS: Record<string, ColorSet> = {
    [FTANodeType.TOP_EVENT]:          { fill: '#fee2e2', stroke: '#dc2626' },
    [FTANodeType.INTERMEDIATE_EVENT]: { fill: '#dbeafe', stroke: '#2563eb' },
    [FTANodeType.BASIC_EVENT]:        { fill: '#dcfce7', stroke: '#16a34a' },
    [FTANodeType.UNDEVELOPED_EVENT]:  { fill: '#fef9c3', stroke: '#ca8a04' },
    [FTANodeType.CONDITIONING_EVENT]: { fill: '#f3e8ff', stroke: '#9333ea' },
    [FTANodeType.HOUSE_EVENT]:        { fill: '#e0f2fe', stroke: '#0284c7' },
    [FTANodeType.EXTERNAL_EVENT]:     { fill: '#f0fdf4', stroke: '#15803d' },
    [FTANodeType.AND_GATE]:           { fill: '#dbeafe', stroke: '#1d4ed8' },
    [FTANodeType.OR_GATE]:            { fill: '#fef3c7', stroke: '#d97706' },
    [FTANodeType.XOR_GATE]:           { fill: '#fee2e2', stroke: '#dc2626' },
    [FTANodeType.INHIBIT_GATE]:       { fill: '#f5f3ff', stroke: '#7c3aed' },
    [FTANodeType.PAND_GATE]:          { fill: '#ecfdf5', stroke: '#059669' },
    [FTANodeType.BLOCK_FUNCTION]:     { fill: '#eff6ff', stroke: '#3b82f6' },
    [FTANodeType.BLOCK_PROCESS]:      { fill: '#f0fdf4', stroke: '#22c55e' },
    [FTANodeType.BLOCK_DECISION]:     { fill: '#fefce8', stroke: '#eab308' },
    [FTANodeType.BLOCK_CONNECTOR]:    { fill: '#f0f9ff', stroke: '#0ea5e9' },
    [FTANodeType.TRANSFER_IN]:        { fill: '#f8fafc', stroke: '#475569' },
    [FTANodeType.TRANSFER_OUT]:       { fill: '#f8fafc', stroke: '#475569' },
};

export const BASIC_COLOR: ColorSet = { fill: '#f8fafc', stroke: '#64748b' };

export function getTypeColors(type: string, mode: 'colorful' | 'basic'): ColorSet {
    return mode === 'colorful' ? (TYPE_COLORS[type] ?? TYPE_COLORS[FTANodeType.INTERMEDIATE_EVENT]) : BASIC_COLOR;
}

export interface PaletteItem { type: FTANodeType; label: string; section: string; }

export const PALETTE_ITEMS: PaletteItem[] = [
    // Events
    { type: FTANodeType.TOP_EVENT,          label: 'Top Event',      section: 'Events' },
    { type: FTANodeType.INTERMEDIATE_EVENT, label: 'Intermediate',   section: 'Events' },
    { type: FTANodeType.BASIC_EVENT,        label: 'Basic Event',    section: 'Events' },
    { type: FTANodeType.UNDEVELOPED_EVENT,  label: 'Undeveloped',    section: 'Events' },
    { type: FTANodeType.CONDITIONING_EVENT, label: 'Conditioning',   section: 'Events' },
    { type: FTANodeType.HOUSE_EVENT,        label: 'House Event',    section: 'Events' },
    { type: FTANodeType.EXTERNAL_EVENT,     label: 'External',       section: 'Events' },
    // Gates
    { type: FTANodeType.AND_GATE,           label: 'AND Gate',       section: 'Gates' },
    { type: FTANodeType.OR_GATE,            label: 'OR Gate',        section: 'Gates' },
    { type: FTANodeType.XOR_GATE,           label: 'XOR Gate',       section: 'Gates' },
    { type: FTANodeType.INHIBIT_GATE,       label: 'Inhibit',        section: 'Gates' },
    { type: FTANodeType.PAND_GATE,          label: 'Priority AND',   section: 'Gates' },
    // Block Diagram
    { type: FTANodeType.BLOCK_FUNCTION,     label: 'Function',       section: 'Block' },
    { type: FTANodeType.BLOCK_PROCESS,      label: 'Process',        section: 'Block' },
    { type: FTANodeType.BLOCK_DECISION,     label: 'Decision',       section: 'Block' },
    { type: FTANodeType.BLOCK_CONNECTOR,    label: 'Connector',      section: 'Block' },
    // Transfer
    { type: FTANodeType.TRANSFER_IN,        label: 'Transfer In',    section: 'Transfer' },
    { type: FTANodeType.TRANSFER_OUT,       label: 'Transfer Out',   section: 'Transfer' },
];
